import React, { useEffect, useState } from 'react';
import { useRequestImmer } from '../../api/hooks';
import { SKUWrapper, StandardProduct, StandardProductEndpoint } from '@/models/sku';
import Loading from '../Loading';
import StandardProductDesc from './Desc';
import SpToGoodsForm, { SpToGoodsFormProps } from './SpToGoodsForm';

type Props = {
  barcode: string;
  onFind?: (standardProduct: StandardProduct) => void;
  onSuccess?: (skuWrapper: SKUWrapper) => void;
  onCancel?: () => void;
  fillSpecificationInfo: SpToGoodsFormProps['fillSpecificationInfo'];
};

type SPQueryResult = SpToGoodsFormProps['product'];

const SpToGoods: React.FC<Props> = ({
  barcode,
  onSuccess = () => {},
  onCancel = () => {},
  onFind = () => {},
  fillSpecificationInfo,
}: Props) => {
  const [mode, setMode] = useState<'SpInfo' | 'GoodsForm'>('SpInfo');
  const {
    payload: spQueryResult,
    setPayload: setSpQueryResult,
    send,
    loading,
    reset,
    error,
  } = useRequestImmer<SPQueryResult>(
    {
      method: 'get',
    },
    {
      manual: true,
    }
  );

  useEffect(() => {
    reset();
    setMode('SpInfo');
    if (barcode) {
      send({
        url: `${StandardProductEndpoint}/${barcode}`,
      }).then();
    }
  }, [barcode]);

  useEffect(() => {
    if (spQueryResult) {
      onFind(spQueryResult);
    }
  }, [spQueryResult]);

  useEffect(() => {
    if (error) {
      setSpQueryResult(
        () =>
          ({
            barcode,
          } as SPQueryResult)
      );
      setMode('GoodsForm');
    }
  }, [error]);

  if (loading) {
    return <Loading />;
  }

  if (mode === 'SpInfo') {
    // if (error) {
    //   return (
    //     <>
    //       <Empty description={error.msg} />
    //       <Button>继续添加</Button>
    //     </>
    //   );
    // } else

    if (spQueryResult) {
      return (
        <StandardProductDesc
          product={spQueryResult}
          onRequestAdd={() => {
            setMode('GoodsForm');
          }}
          onRequestCancel={onCancel}
        />
      );
    }
  } else if (mode === 'GoodsForm') {
    return (
      <SpToGoodsForm
        fillSpecificationInfo={fillSpecificationInfo}
        product={spQueryResult}
        onSuccess={skuWrapper => {
          setMode('SpInfo');
          reset();
          onSuccess(skuWrapper);
        }}
        onCancel={onCancel}
      />
    );
  }

  return <></>;
};

export default SpToGoods;
